import type {ReactNode} from 'react';
import {useLocation} from 'react-router-dom';
import type {TreeResponse} from 'src/api/ProactApiClient';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {DocumentTreeBrowser} from './DocumentTreeBrowser';
import {documentTreeRootId} from './documentTreeBrowserState';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

export interface DocumentsBrowserShellProps {
  /** Tree node id of the record the page is showing; undefined until the record loads. */
  selectedId?: string;
  children: ReactNode;
}

/** Document tree pane plus the module's node-select navigation, for every Documents route. */
export const DocumentsBrowserShell = ({
  selectedId,
  children,
}: DocumentsBrowserShellProps) => {
  const navigate = useAppNavigate();
  const location = useLocation();

  const handleSelect = (id: string, node?: TreeResponse) => {
    if (node?.kind === 'file') {
      navigate(PathUtility.DocumentManagerViewFile(id, 'content'));
      return;
    }
    // Only the Documents tab is folder-scoped, so a folder click leaves any other tab.
    const search = new URLSearchParams(location.search);
    search.delete('tab');
    navigate({
      pathname: PathUtility.DocumentsManagerList(
        id === documentTreeRootId ? 0 : id
      ),
      search: search.toString(),
    });
  };

  return (
    <DocumentTreeBrowser selectedId={selectedId} onSelect={handleSelect}>
      {children}
    </DocumentTreeBrowser>
  );
};
